import { render, staticRenderFns } from "./ChannelSettingsDialog.vue?vue&type=template&id=aac308e8&scoped=true"
import script from "./ChannelSettingsDialog.vue?vue&type=script&lang=js"
export * from "./ChannelSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./ChannelSettingsDialog.vue?vue&type=style&index=0&id=aac308e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac308e8",
  null
  
)

export default component.exports